import { useRef } from 'preact/hooks';
import { route } from 'preact-router';
import { error, loading } from '../store/state';
import { login } from '../store/actions/auth.actions';
import { Icon } from '../components/Icon';

export function LoginView() {
  const emailRef = useRef<HTMLInputElement>(null);
  const passwordRef = useRef<HTMLInputElement>(null);

  const onSubmit = (e: Event) => {
    e.preventDefault();
    login(emailRef.current!.value.trim(), passwordRef.current!.value);
  };

  return (
    <div class="login-wrap">
      <div class="login-brand">
        <span class="brand-icon">
          <Icon name="wrench" size={22} />
        </span>
      </div>
      <h1>Visitas Técnicas</h1>
      <p class="subtitle">Iniciá sesión</p>
      <form onSubmit={onSubmit}>
        <label>Email</label>
        <input ref={emailRef} type="email" required autocomplete="username" />
        <label>Contraseña</label>
        <input ref={passwordRef} type="password" required autocomplete="current-password" />
        <button class="primary" type="submit" disabled={loading.value}>
          {loading.value ? (
            <>
              <span class="spinner"></span>Ingresando…
            </>
          ) : (
            'Ingresar'
          )}
        </button>
      </form>
      <p style={{ textAlign: 'center', marginTop: 20, fontSize: 14, color: 'var(--text-muted)' }}>
        <a
          href="/registro"
          style={{ color: 'var(--primary)' }}
          onClick={(e) => {
            e.preventDefault();
            error.value = null;
            route('/registro');
          }}
        >
          Registrar empresa
        </a>
      </p>
    </div>
  );
}
